import React from 'react';
import { Icon } from 'design-system-web';
import { useTranslation } from 'react-i18next';
import { useExpandableText } from 'pages/portal/admin/channel/service-requests/hooks/useExpandableText';
import {
  FONT_AWESOME_SOLID,
  FONT_AWESOME_REGULAR,
  ICON_SET_FONTAWESOME,
} from 'lane-shared/helpers/constants/icons';
import styles from './ServiceRequestFeedback.scss';

interface ServiceRequestFeedbackProps {
  feedback: {
    rating: number;
    comment?: string | null;
  };
}

const FEEDBACK_TEXT_LIMITS = {
  PREVIEW: 30,
  FULL: 200,
};

const STAR_RATING_LEVELS = [1, 2, 3, 4, 5];

export function ServiceRequestFeedback({
  feedback,
}: ServiceRequestFeedbackProps) {
  const { t } = useTranslation();

  const { isExpanded, visibleText, canExpand, setIsExpanded } =
    useExpandableText({
      text: feedback.comment,
      previewLimit: FEEDBACK_TEXT_LIMITS.PREVIEW,
      fullLimit: FEEDBACK_TEXT_LIMITS.FULL,
    });

  return (
    <>
      <span>{t('web.admin.serviceRequest.tenantFeedback')}</span>
      <div className={styles.starRating}>
        {STAR_RATING_LEVELS.map((star, index) => {
          const isFilled = star <= feedback.rating;

          return (
            <span key={index} className={isFilled ? 'filled' : ''}>
              <Icon
                name="star"
                size="small"
                set={ICON_SET_FONTAWESOME}
                type={isFilled ? FONT_AWESOME_SOLID : FONT_AWESOME_REGULAR}
              />
            </span>
          );
        })}
      </div>
      <span>
        {visibleText}{' '}
        {canExpand && (
          <button
            type="button"
            onClick={() => setIsExpanded(prev => !prev)}
            className={styles.commentLink}
          >
            {isExpanded
              ? t('web.admin.serviceRequest.viewLess')
              : t('web.admin.serviceRequest.viewMore')}
          </button>
        )}
      </span>
    </>
  );
}
